import { useEffect } from "react";
import { createModal } from "../hooks/createModal";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { ENUMS } from "../utils/Enums";
import { FILTER } from "../utils/Struct";
import { useTabs } from "../hooks/useTabs";
import { pubCall } from "../utils/PubSub";
import Confirm from "../popups/Confirm";
import { showError } from "../ui/Message";

import Input from "../ui/Input";
import Nav from "../ui/Nav";

export default function CustomerAlert(props) {
    const { controller = "", route = "", signal = {}, alert = {}, onClose = () => { }, selected = {}, updateRow = () => { }, edit = false, callback = () => { } } = props;

    const alertMessage = selected.alert_message || "";
    const fields = [
        {type: "row", key: "alert0", value: alertMessage.slice(0, 40) },
        {type: "row", key: "alert1", value: alertMessage.slice(40, 80) },
        {type: "row", key: "alert2", value: alertMessage.slice(80, 120) },
        {type: "row", key: "date", value: "" },
    ]

    const { tabs, index, help, update, updateSkip, setIndex, next, prev, refs, getVal, editProps } = useTabs(fields, "alert0");

    const onSave = (deleteFlag) => {
        const alert0 = (getVal("alert0") || "");
        const alert1 = (getVal("alert1") || "");
        const alert2 = (getVal("alert2") || "");
        const alertMessage = alert0 + alert1 + alert2;
        
        const dataToSave = {
            ...selected,
            alert_message: alertMessage
        };

        if (deleteFlag){
            window.bm_state.value = ROUTES.HELPERS.CONFIRM;
            createModal({
                alert: true,
                component: <Confirm controller={controller} events={[KBD.D, KBD.U]} title={"Remove Alert"} signal={signal} route={ROUTES.HELPERS.CONFIRM} />, closable: true, callback: (e) => {
                    window.bm_state.value = route;
                    if (e) {
                        pubCall("customer.edit", { ship_to: selected.ship_to, customer_info: { ...selected, alert_message: "" } }, (_s, _r) => {
                            if (_s) {
                                callback();
                                updateRow(_r, selected.ship_to);                            
                            } else {
                                showError(_r);
                            }
                        })
                    }
                }
            })
        } else {
            pubCall("customer.edit", { customer_info: dataToSave, ship_to: selected.ship_to }, (_s, _r) => {
                if (_s) {
                    callback();
                    updateRow(_r, selected.ship_to);
                }
            })
        }

    }

    const navItems = [
        { key: KBD.ALT_E, text: "@Edit", action: () => callback("edit") },
        { key: KBD.ALT_D, text: "@Delete", action: () => onSave(true) },
        { key: KBD.ESCAPE, text: "Esc", action: () => callback() },
        { key: KBD.ARROW_DOWN, action: () => callback() },
        { key: KBD.ARROW_UP, action: () => callback() },
    ]

    const editNav = [
        { key: KBD.PAGE_DOWN, action: () => onSave() },
        { key: KBD.ESCAPE, action: () => callback() },
        { key: KBD.ARROW_DOWN, action: () => callback("next") },
        { key: KBD.ARROW_UP, action: () => callback("prev") },
    ] 


    useEffect(() => {
        const action = edit ? editNav : navItems;
        const cleanup = listen(props.controller, props.route, action, () => { }, [KBD.ENTER, KBD.ESCAPE, KBD.ALT_D, KBD.PAGE_DOWN, KBD.PAGE_UP, KBD.ARROW_DOWN, KBD.ARROW_UP]);
        return cleanup;
    }, [edit, alert, index, tabs]);

    useEffect(() => {
        if (edit && refs.current["alert0"]) {
            refs.current["alert0"].focus();
        }
    }, [edit]);

    const renderAlert = () => {
        const total = 3;
        return Array.from({ length: total}).map((_, i) => {
            const isFirst = 1 === 0;
            const isLast = i === total - 1;
            const key = `alert${i}`;
            const prevKey = `alert${i - 1}`;
            const nextKey = `alert${i + 1}`;
            return (
                <Input
                    key={key}
                    ref={el => (refs.current[key] = el)}
                    style={{
                        fontFamily: "var(--font-mono)",
                        fontSize: "17px",
                        borderTopLeftRadius: isFirst ? "4px" : "0px",
                        borderTopRightRadius: isFirst ? "4px" : "0px",
                        borderBottomLeftRadius: isLast ? "4px" : "0px",
                        borderBottomRightRadius: isLast ? "4px" : "0px",
                    }}
                    width={375}
                    maxLength={40}
                    {...editProps(`alert${i}`)}
                    tabMin={
                        !isFirst
                            ? () => refs.current[prevKey]?.focus()
                            : () => ""
                    }
                    tabMax={
                        !isLast
                            ? () => refs.current[nextKey]?.focus()
                            : () => ""
                    }
                    onEnter={() => (isLast) ? "" : refs.current[nextKey]?.focus()}
                    onBackSpace={() => {
                        if (getVal(key) === "") {
                            if (!isFirst) {
                                refs.current[prevKey]?.focus();
                            }
                        }
                    }}
                    autoselect={false}
                />
                );
            })
    }



    const renderAlertDisplay = () => {
        const text = selected.alert_message || "";
        const total = 3;
        const chunks = [];
        
        for (let i = 0; i < total; i++) {
            chunks.push(text.slice(i * 40, (i + 1) * 40));
        }
        
        return chunks.map((chunk, i) => {
            const isFirst = i === 0;
            const isLast = i === total - 1;
            return (
                <Input
                    key={`display-${i}`}
                    value={chunk}
                    style={{
                        fontFamily: "var(--font-mono)",
                        fontSize: "17px",
                        textAlign: "center",
                        borderTopLeftRadius: isFirst ? "4px" : "0px",
                        borderTopRightRadius: isFirst ? "4px" : "0px",
                        borderBottomLeftRadius: isLast ? "4px" : "0px",
                        borderBottomRightRadius: isLast ? "4px" : "0px",
                    }}
                    width={375}
                />
            );
        });
    };

    switch(edit) {
        case true: 
            return (
                <div style={{ "fontSize": "15px", "width": "386px" }}>
                    {renderAlert()}
                </div>
            );
        default:
            return (
                <div style={{ "fontSize": "15px", "width": "386px" }}>
                    {renderAlertDisplay()}
                    <div className="shim"/><div className="shim"/>
                    <Nav nav={navItems}/>
                </div>
            )
    }
}